import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { AlertTriangle, LogOut } from 'lucide-react';

const NoAccess = () => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = async () => {
        await logout();
        navigate('/login');
    };

    return (
        <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center p-4">
            <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
                <div className="w-16 h-16 bg-amber-50 rounded-full flex items-center justify-center mx-auto mb-6">
                    <AlertTriangle size={32} className="text-amber-500" />
                </div>
                
                <h1 className="text-2xl font-bold text-slate-900 mb-2">Acceso Restringido</h1>
                
                <p className="text-slate-600 mb-8">
                    Hola <span className="font-semibold">{user?.displayName}</span>,<br/>
                    Su usuario no tiene servicios habilitados actualmente. Por favor, contacte al administrador o a soporte para solicitar acceso al Campus o al Portal de Suscripción.
                </p>

                <button 
                    onClick={handleLogout}
                    className="inline-flex items-center gap-2 px-6 py-3 bg-slate-900 text-white rounded-lg hover:bg-slate-800 transition-colors"
                >
                    <LogOut size={18} />
                    <span>Cerrar Sesión</span>
                </button>
            </div>
        </div>
    );
};

export default NoAccess;
